





































helpers = require('../../helpers.coffee')

view_model = {
  components:
    specificTemplatesList: require '../specific_templates/list'
    templateForm: require '../templates/form'

  props:
    flow:
      required: true

    contact:
      required: true

  data: ->
    id: 'edit-specific-templates'
    fetching: true
    current_action: {}
    current_template: {}
    form_options:
      name: 'hide'
      category: 'hide'
      show_footer: false
      modal: true
      focus: false
      

  computed:
    show_form: ->
      Object.keys(@current_action).length != 0 && Object.keys(@current_template).length != 0

    title: ->
      if !@show_form then @$t('template.modal.edit.title') else this.$t('template.modal.edit.titleSpecific', { name: @current_template.name })

    business_name: ->
      @contact?.business?.name

    has_valid_email_actions: ->
      @flow.actions.some (action) -> action.template_id

    template_kind: ->
      return 'email' unless @current_action?
      [_..., kind] = @current_action.manual_task_parameters.service.split('::')
      kind.toLowerCase()

  methods:
    openSpecificTemplateForm: (data) ->
      @current_action = data.action
      @current_template = @buildTemplate()

    buildTemplate: ->
      template = Object.assign({}, @current_action.template)
      specific_template = @findSpecificTemplate()
      if specific_template
        template.id = specific_template.id
        template.kind = @template_kind
        template.subject = specific_template.subject
        template.body = specific_template.body
        template.signature = specific_template.signature
      template

    findSpecificTemplate: ->
      @current_action.contact_specific_templates.find (template) =>
        template.belongsToContact(@contact) && !template._destroy

    updateSpecificTemplate: (data) ->
      data.attr.template.contact_id = @contact.id
      old_specific_template = @removeSpecificTemplate(@current_action)
      specific_template = @createSpecificTemplate(data.attr.template)
      specific_template.id = if old_specific_template then old_specific_template.id else null
      specific_template.flow_action_id = @current_action.id
      @addSpecificTemplate(@current_action, specific_template)
      Loader.off()
      @back()

    removeSpecificTemplate: (action) ->
      step = action.step
      contact_ids = @flow.actions[step].contact_specific_templates.map (template) ->
        template.contact_id || template.contact.email
      index = contact_ids.indexOf(@contact.id || @contact.email)
      if index > -1
        removed = @flow.actions[step].contact_specific_templates.splice index, 1
        return removed[0]
      null

    createSpecificTemplate: (data) ->
      IntercomCtrl.trackEvent('Fluxo - Criação de template específico')
      contact_specific_template = new ContactSpecificTemplate({
        id: data.id,
        flow_action_id: data.flow_action_id,
        template_id: data.id,
        subject: data.subject,
        kind: data.kind,
        body: data.body,
        signature: data.signature,
        contact: @contact
      })
      if data.contact_id
        contact_specific_template.contact_id = data.contact_id
      else
        contact_specific_template.contact_email = @contact.email

      contact_specific_template

    destroySpecificTemplate: (data) ->
      action = data.action
      specific_template = @removeSpecificTemplate(action)
      if specific_template.id
        specific_template._destroy = true
        @addSpecificTemplate(action, specific_template)
      @$emit 'specific-template-destroy', { action: action, specific_template: specific_template }

    addSpecificTemplate: (action, specific_template) ->
      @flow.actions[action.step].contact_specific_templates.push specific_template
      @$emit 'specific-template-add', { action: action, specific_template: specific_template }

    show: (data) ->
      @current_action = {}
      @current_template = {}
      jQuery("##{@id}").modal 'show' if data.id == @id

    back: ->
      @current_action = {}
      @current_template = {}

    submit: ->
      EventsBus.$emit 'TemplateForm:Submit'

  created: ->
    EventsBus.$on 'confirm-modal-show', @show

  beforeDestroy: ->
    EventsBus.$off 'confirm-modal-show', @show
}

exports.default = helpers.vue_include(
  view_model, helpers.form
)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/specific_templates/modal.vue